// extracted by mini-css-extract-plugin
export default {"chatPageChat4":"Chat4_chatPageChat4__D3eyq"};